<script>
  import { setResources, settings } from "./resources";
  import { trimSlash, umbracoMapper } from "../helpers";
  import { activateRouter } from "./routing";
  import type { DataHandlerType, IPage, IPanel, IPageData } from "../types";

  export let pagesList: IPage[];
  export let panelsList: IPanel[];
  export let api: string;
  export let dataHandler: DataHandlerType;

  let isLoaded: boolean = false;
  let data: IPageData | null;
  let page: IPage;

  setResources(api).then(() => {
    activateRouter(setPageData);
    isLoaded = true;
  });

  function setPageData(url: string) {
    const fullUrl = encodeURIComponent(window.location.origin + "/" + url);
    const currentPath = trimSlash(window.location.pathname);

    if (pagesList[currentPath]) {
      data = null;
      return (page = pagesList[currentPath]);
    }

    fetch(`${api}/node/getByurl?url=${fullUrl}`)
      .then((r) => dataHandler(r, settings))
      .then((r) => (r?.status == 204 || r?.ok === false ? r.text() : r.json()))
      .then((dataByUrl) => {
        data = umbracoMapper(dataByUrl) || null;
        page = pagesList[data?.contentTypeAlias || "404"];
      });
  }
</script>

{#if isLoaded}
  <svelte:component this={page?.layout} {data}>
    <svelte:component this={page?.component} {data}>
      {#each data?.panels || [] as panel}
        <svelte:component
          this={panelsList[panel.contentTypeAlias]}
          data={panel}
        />
      {/each}
    </svelte:component>
  </svelte:component>
{/if}
